import { Component, OnInit } from '@angular/core';
import * as fromApp from '../../../store/app.reducers';
import * as fromUser from '../../../user/store/user.reducers';
import * as fromPost from '../store/post.reducers';
import * as PostActions from '../store/post.actions';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-post-list',
    templateUrl: './post-list.component.html',
    styleUrls: ['./post-list.component.scss'],
    standalone: false
})
export class PostListComponent implements OnInit {

  postState: Observable<fromPost.State>;
  userState: Observable<fromUser.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.postState = this.store.select('post');
    this.userState = this.store.select('user');
    this.store.dispatch(
      new PostActions.GetAudits()
    );
  }

}
